import { render, staticRenderFns } from "./OrderDashboard.vue?vue&type=template&id=557ff0a9&scoped=true"
import script from "./OrderDashboard.vue?vue&type=script&lang=js"
export * from "./OrderDashboard.vue?vue&type=script&lang=js"
import style0 from "./OrderDashboard.vue?vue&type=style&index=0&id=557ff0a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557ff0a9",
  null
  
)

export default component.exports